import { render, staticRenderFns } from "./foreign-visits-diff-places.vue?vue&type=template&id=706c6300&scoped=true"
import script from "./foreign-visits-diff-places.vue?vue&type=script&lang=ts"
export * from "./foreign-visits-diff-places.vue?vue&type=script&lang=ts"
import style0 from "./foreign-visits-diff-places.vue?vue&type=style&index=0&id=706c6300&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c6300",
  null
  
)

export default component.exports